import { loc } from "../i18n/survey";

enum WorkoutTrackingApp {
  Yes = "Yes",
  Not_right_now="I have in the past",
  No = "No",

}

const workoutTrackingAppQuestion = {
  name: "workouttrackingapp",
  descriptionLocation: "underTitle",
  title: loc("quiz.trackingApp.workoutTitle"),
  description: loc("quiz.shared.startingPoint"),
  type: "radiogroup",
  choices: [
    { value: WorkoutTrackingApp.Yes, text: loc("quiz.trackingApp.choices.yes") },
    { value: WorkoutTrackingApp.Not_right_now, text: loc("quiz.trackingApp.choices.inThePast") },
    { value: WorkoutTrackingApp.No, text: loc("quiz.trackingApp.choices.no") },
  ],
  isRequired: true,
};

export { WorkoutTrackingApp, workoutTrackingAppQuestion };
